import { ApiParams } from './../../interfaces/common/ApiParams'
import axios from 'axios'
import { BASE_PATH_DISTRO } from '../../constants'

export const getSectors = (params: ApiParams = {}) => {
  return axios
    .get(`${BASE_PATH_DISTRO}/data/klasifikatora_vērtību_saraksts`, {
      params: {
        klasifikatora_kods: 'BIRKA',
        ...params,
      },
    })
    .then((response) => response.data)
}
